import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export interface IEnv {
    getValue: <T>(envName: string) => T | null;
    getValueWithDefault: <T>(envName: string, defaultValue: T) => T;
    getNumber: (name: string, defaultValue?: number) => number;
    getBoolean: (name: string, defaultValue?: boolean) => boolean;
    getString: (name: string, defaultValue?: string) => string;
    allValues: () => Record<number | string | symbol, unknown>;
}

export function injectENV(container: IContainer = injectOrBuildContainer()): IEnv {
    return container.get<IEnv>(TYPES.IEnv);
}

export function bindENV(val: IEnv, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IEnv>(TYPES.IEnv, val);
}

export function unbindENV(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IEnv);
}
